import { ColorTokenKey } from '@faire/web-api--source/indigofair/data/ColorTokenKey';
import { TextStyleType } from '@faire/web-api--source/indigofair/data/TextStyleType';

export namespace ISlateTextStyle {
  export enum TextDecorator {
    TEXT_DECORATOR_UNKNOWN = 'TEXT_DECORATOR_UNKNOWN',
    EMPHASIS = 'EMPHASIS',
    STRIKE_THROUGH = 'STRIKE_THROUGH',
    UNDERLINE = 'UNDERLINE',
  }

  /**
   * DEPRECATED hardcode on clients instead
   */
  export enum TextJustification {
    TEXT_JUSTIFICATION_UNKNOWN = 'TEXT_JUSTIFICATION_UNKNOWN',
    START = 'START',
    CENTER = 'CENTER',
    END = 'END',
  }

  /**
   * Return an instance of ISlateTextStyle with the provided fields. Any field not
   * listed will be populated with an empty value (an empty array,
   * or undefined, whichever is valid for the type of the value.)
   */
  export const build = (partial?: Partial<ISlateTextStyle>): ISlateTextStyle =>
    ({
      decorators: [],
      ...(partial ?? {}),
    }) as ISlateTextStyle;
}

export interface ISlateTextStyle {
  type: keyof typeof TextStyleType | undefined;
  decorators: Array<keyof typeof ISlateTextStyle.TextDecorator>;
  color: keyof typeof ColorTokenKey | undefined;
  /**
   * max lines and textJustification at the SlateTextStyle level are deprecated
   * define these values on the client side instead
   * @deprecated
   */
  max_lines: number | undefined;
  /**
   * @deprecated
   */
  text_justification:
    | keyof typeof ISlateTextStyle.TextJustification
    | undefined;
}
